export const products = {
  material: 'Materiais',
  medicine: 'Medicamentos',
  service: 'Serviços',
};

export function getName(value) {
  return products[value];
}
